import { TICKET_LOGO } from "./contantsTemplate";

export const pdfTiqueteTransaccionTemplate = async (
  info: any
): Promise<any> => {
  // Adaptación del tiquete PDF a la información y condicionales del modal de la transacción
  const formatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  });
  const transaction = info.transaction || {};
  const calculation = info.calculation || {};
  const badge = (status: string) => {
    if (status === "pending") return { text: "Pendiente", color: "#ffc107" };
    if (status === "finished") return { text: "Completado", color: "#198754" };
    if (status === "transshipment")
      return { text: "Transbordo", color: "#0d6efd" };
    if (status === "canceled") return { text: "Cancelado", color: "#dc3545" };
    return { text: status, color: "#6c757d" };
  };

  // Helper para mostrar campo solo si existe
  const field = (label: string, value: any) => [
    {
      text: label,
      borderColor: ["#fff", "#fff", "#fff", "#fff"],
      alignment: "left",
      bold: true,
    },
    {
      text: value ?? "",
      borderColor: ["#fff", "#fff", "#fff", "#fff"],
      alignment: "right",
    },
  ];

  // Construcción dinámica del body según condicionales del modal
  const body = [];
  body.push(field("Contenedor", transaction.container));
  body.push(
    field("Tipo de contenedor", transaction.ContainerType?.description)
  );
  body.push(field("Nombre del conductor", transaction.driverName));
  body.push(field("Documento del conductor", transaction.driverId));
  body.push(field("Teléfono del conductor", transaction.driverPhone));
  body.push(field("Placa del vehículo", transaction.vehiclePlate));
  // Estado con badge
  body.push([
    {
      text: "Estado",
      borderColor: ["#fff", "#fff", "#fff", "#fff"],
      alignment: "left",
      bold: true,
    },
    {
      text: badge(transaction.status).text,
      borderColor: ["#fff", "#fff", "#fff", "#fff"],
      alignment: "right",
      bold: true,
    },
  ]);
  body.push(
    field(
      `${
        transaction.transactionType == "transshipment"
          ? "Fecha de ingreso"
          : "Fecha de creación"
      }`,
      transaction.date
        ? new Intl.DateTimeFormat("es-US", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
            timeZone: "UTC",
          }).format(new Date(transaction.date))
        : ""
    )
  );
  if (
    !["canceled", "pending"].includes(transaction.status) &&
    transaction.checkOutDate
  ) {
    body.push(
      field(
        "Fecha de salida",
        transaction.checkOutDate
          ? new Intl.DateTimeFormat("es-US", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: false,
              timeZone: "UTC",
            }).format(new Date(transaction.checkOutDate))
          : ""
      )
    );
  }

  // Si la transacción no está cancelada y hay cálculo, mostrar detalles
  if (!["canceled", "pending"].includes(transaction.status) && calculation) {
    body.push(
      field(
        "Tipo de transacción",
        calculation.transactionType === "storage" ? "Almacenaje" : "Transbordo"
      )
    );
    if (calculation.transactionType === "storage") {
      body.push(field("Días totales", calculation.totalDays));
      body.push(field("Días libres", calculation.freeDays));
      body.push(field("Días a cobrar", calculation.chargeableDays));
    }
    body.push(
      field(
        "Tarifa base",
        calculation.baseRate ? formatter.format(calculation.baseRate) : ""
      )
    );
    if (calculation.transactionType === "storage") {
      body.push(
        field(
          "Tarifa diaria",
          calculation.dailyRate ? formatter.format(calculation.dailyRate) : ""
        )
      );
    }
    if (transaction.discount) {
      body.push(
        field(
          "Descuento",
          transaction.discount ? formatter.format(transaction.discount) : ""
        )
      );
    }
    body.push(
      field(
        "Monto total",
        calculation.totalAmount ? formatter.format(calculation.totalAmount) : ""
      )
    );
  }
  body.push(field("Observaciones", transaction.observations));

  return {
    pageSize: {
      width: 300,
      height: "auto",
    },
    pageMargins: [20, 20, 20, 25],
    content: [
      {
        image: TICKET_LOGO,
        alignment: "center",
        width: 50,
        height: 50,
      },
      {
        text: '"PIKI7 SAS"',
        fontSize: 12,
        bold: true,
        alignment: "center",
      },
      {
        text: "NIT. 900.368.831-9",
        fontSize: 10,
        alignment: "center",
      },
      {
        text: `Tiquete`,
        alignment: "center",
        fontSize: 14,
        bold: true,
        margin: [0, 18, 0, 18],
      },
      {
        style: "tableContent",
        table: {
          widths: [150, "auto"],
          body: body,
        },
      },
    ],
    styles: {
      headerTableData: {
        bold: true,
        fillColor: "#95A5A6",
        borderColor: "#fff",
      },
      headerTableStatistical: {
        alignment: "center",
        bold: true,
        fillColor: "#95A5A6",
        margin: [10, 0],
      },
      footer: {
        opacity: 0.4,
        fontSize: 11,
      },
      tableFilter: {
        bold: true,
      },
      tableContent: {
        fontSize: 10,
      },
    },
  };
};
